import React from 'react';

import { CreateWatchlistModal } from '~/components/watchlist/create-watchlist-modal/CreateWatchlistModal';
import { useWatchlistActions } from '~/hooks/use-watchlist-actions/useWatchlistActions';
import { ActionWatchlistCreate } from '~/stores/use-chat/assistant-response.type';

interface CreateWatchlistPromptProps {
  action: ActionWatchlistCreate;
  isOpen: boolean;
  closeModal: () => void;
}

export const CreateWatchlistPromptModal = ({
  action,
  isOpen,
  closeModal,
}: CreateWatchlistPromptProps) => {
  const { createNewList, watchlistErrorText, createListLoading, clearError } =
    useWatchlistActions();

  const onCreateList = async (name: string) => {
    await createNewList(name, action.data.entities);
    closeModal();
  };

  return (
    <CreateWatchlistModal
      isOpen={isOpen}
      onClose={closeModal}
      onSubmit={name => onCreateList(name)}
      isLoading={createListLoading}
      watchlistErrorText={watchlistErrorText}
      clearError={clearError}
    />
  );
};
